import { render, staticRenderFns } from "./SharedProfiles.vue?vue&type=template&id=0b4f13ea&"
import script from "./SharedProfiles.vue?vue&type=script&lang=js&"
export * from "./SharedProfiles.vue?vue&type=script&lang=js&"
import style0 from "./SharedProfiles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports